import { getFlagUrl } from 'utils/userUtils';

interface FriendProfileProps {
  userInfo: UserInfo;
  className?: string;
  onClick?: () => void;
  trailing?: React.ReactNode;
}

const FriendProfile: React.FC<FriendProfileProps> = ({ className = '', userInfo, onClick, trailing }) => {
  return (
    <div className={`flex h-14 items-center justify-between ${className}`} onClick={onClick}>
      <div className="flex items-center gap-[var(--spacing-md)]">
        <img src={PhotoManager.getPhotoURL(userInfo, false)} className="h-14 w-14 rounded-full" alt={userInfo.nick} />
        <div className="flex flex-col gap-[var(--spacing-sm)]">
          <div className="flex h-6 items-center gap-[var(--spacing-xs)]">
            {userInfo.gender && <img src={`/imgweb/icon/ic_${userInfo.gender}.svg`} className="h-6 w-6" alt={userInfo.gender} />}
            <span className="typography-headline-lg text-base-txt-primary">{userInfo.nick}</span>
          </div>
          <div className="flex h-6 items-center gap-[var(--spacing-xs)]">
            <img src={getFlagUrl(userInfo.country, userInfo.specialLocale)} className="h-6 w-6 rounded-xs" alt={userInfo.country} />
            <span className="typography-body-sm text-base-txt-secondary">{getCountryName(userInfo.country)}</span>
          </div>
        </div>
      </div>
      {trailing}
    </div>
  );
};

export default FriendProfile;
